export default {
  xs: 1,
  sm: 1.2,
  md: 1.5,
  lg: 2
};